import React from 'react'
import "./searchCard.css"

function SearchBlogCard({ blogData }) {
    return (
        <React.Fragment>
            <a href={`https://wisemonkeys.info/blog/${blogData.slug}`}>
                <div className="blogCard overflow-hidden rounded-2xl cursor-pointer border">
                    <img src={blogData.banner_image} alt="blogHeroImage" className="w-full h-28 object-cover" />
                </div>
            </a>
        </React.Fragment>
    )
}

export default SearchBlogCard
